import { Link, useLocation } from "react-router-dom";

function labelize(seg) {
    const l = decodeURIComponent(seg.replace(/-/g, " "));
    // rút gọn nếu quá dài cho mobile
    return l.length > 28 ? l.slice(0, 25) + "…" : l;
}

export default function Breadcrumb() {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter(Boolean);

    return (
        <nav className="text-sm mb-4" aria-label="Breadcrumb">
            <ol className="flex flex-wrap items-center gap-1 text-gray-600">
                <li>
                    <Link to="/" className="hover:text-red-600">Trang chủ</Link>
                </li>
                {pathnames.map((name, idx) => {
                    const routeTo = "/" + pathnames.slice(0, idx + 1).join("/");
                    const isLast = idx === pathnames.length - 1;
                    const label = labelize(name);
                    return (
                        <li key={routeTo} className="flex items-center gap-1">
                            <span>/</span>
                            {isLast ? (
                                <span className="font-medium text-gray-800">{label}</span>
                            ) : (
                                <Link to={routeTo} className="hover:text-red-600">{label}</Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
